import { render } from "./RepDshSummary2ROClinic.vue?vue&type=template&id=3675a7ce"
import script from "./RepDshSummary2ROClinic.vue?vue&type=script&lang=js"
export * from "./RepDshSummary2ROClinic.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\mlab\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__